import { render, staticRenderFns } from "./ComparePortfoliosModalWrapper.vue?vue&type=template&id=156c7726"
import script from "./ComparePortfoliosModalWrapper.vue?vue&type=script&lang=js"
export * from "./ComparePortfoliosModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports